// react
import React, { Component } from 'react'

// components
import { Button } from '@st-operations/uikit/src/v2/index.js'
import Header from '_components/header/index.jsx'

// lib
import downloadCSV from '../lib/downloadCSV.js'

class LiveRamp extends Component {
  constructor(props) {
    super(props)
  }

  transformCSV = () => {
    // ensure a csv is selected
    let csv = document.getElementById('liveramp-csv-input').files[0]
    if (!csv) return

    // prepare the payload
    let data = new FormData()
    data.append('csv', csv)

    // prepare the url
    let url = `${window._api.backend}/custom-audiences/liveramp.csv`

    // prepare the request
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url)
    xhr.setRequestHeader('Authorization', `Bearer ${window._api.token}`)

    // set handler for request response
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        downloadCSV(xhr.response, 'liveramp')
      }
    }

    // send the request
    xhr.send(data)
  }

  render() {
    return (
      <div id="liveramp-page">
        <Header title="LiveRamp" />
        <h4>Numerical ID To Text ID CSV Transformation</h4>
        <input accept="text/csv" id="liveramp-csv-input" type="file" />
        <Button onClick={this.transformCSV}>Submit</Button>
      </div>
    )
  }
}

// export
export default LiveRamp
